import * as Yup from "yup";
import i18n from "../i18n";

export const BuildingsConfigurationSchema = Yup.object({
  buildingNameEn: Yup.string().required(
    i18n.language === "en"
      ? "Building Name (English) is required"
      : "مطلوب اسم المبنى (باللغة الإنجليزية)."
  ),
  buildingNameAr: Yup.string().required(
    i18n.language === "en"
      ? "Building Name (Arabic) is required"
      : "اسم المبنى (عربي) مطلوب"
  ),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required" : "الموقع مطلوب"
  ),
  link: Yup.string().required(
    i18n.language === "en" ? "Link is required" : "الرابط مطلوب"
  ),
  description: Yup.string().nullable(),
  locationPhoto: Yup.mixed().when("$havePhoto", {
    is: true,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema.required(
        i18n.language === "en"
          ? "Location photo is required"
          : "صورة الموقع مطلوبة"
      ),
  }),
});
